// Breadcrumbs go *back* to a page instead of pushing it again: Summary → "Job Details" returns to the Job Details
// entry already in the history, so Back from there reaches the list (not Summary / Equipment).
// vue-router 4 keeps a position number in history.state; we remember it per path (sessionStorage, per tab).
const KEY = "fxHistPos";

const read = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

// router.afterEach: this path now sits at the current position; entries from here on were replaced or dropped
export function recordHistoryPosition(path) {
  const pos = window.history.state?.position;
  if (typeof pos !== "number") return;
  const map = read();
  for (const key of Object.keys(map)) if (map[key] >= pos) delete map[key];
  map[path] = pos;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // storage blocked: breadcrumbs just replace
  }
}

// go back to `to` when it is earlier in this tab's history, else replace the current entry with it (never push)
export function goBackTo(router, to) {
  const path = router.resolve(to).path;
  const target = read()[path];
  const current = window.history.state?.position;
  if (typeof target === "number" && typeof current === "number" && target < current) router.go(target - current);
  else router.replace(to);
}
